// This file was automatically generated from uiwidget.LegacyMindreader.html.
// Please don't edit this file by hand.

goog.provide('el8.template.uiwidget.LegacyMindreader');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.LegacyMindreader.container = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown el8ActionsMenuDialog"><div class="mr-dropdown-content el8MRContainer">', (opt_data.hasCountInfo) ? '<div class="mr-results-info el8MRInformText"></div>' : '');
  var sectionList481 = opt_data.sections;
  var sectionListLen481 = sectionList481.length;
  if (sectionListLen481 > 0) {
    for (var sectionIndex481 = 0; sectionIndex481 < sectionListLen481; sectionIndex481++) {
      var sectionData481 = sectionList481[sectionIndex481];
      output.append((sectionData481.title) ? '<p class="mr-title-' + soy.$$escapeHtml(sectionData481.name) + ' mr-descriptionText mr-subheader el8MRHeader">' + soy.$$escapeHtml(sectionData481.title) + '</p>' : '', '<div class="mr-', soy.$$escapeHtml(sectionData481.name), ' mr-subheader el8MRSection"></div>');
    }
  } else {
    output.append('<div class="mr-matches el8MRSection"></div>');
  }
  output.append((opt_data.hasActions) ? '<div class="mr-actions"></div>' : '', '</div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.LegacyMindreader.noMatchesFyi = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="mr-fyi el8MRInformText">', (! opt_data.text) ? 'No matches found' : soy.$$escapeHtml(opt_data.text), '</p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.uiwidget.LegacyMindreader.item = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="mr-dropdown-item');
  var cList509 = opt_data.classes;
  var cListLen509 = cList509.length;
  for (var cIndex509 = 0; cIndex509 < cListLen509; cIndex509++) {
    var cData509 = cList509[cIndex509];
    output.append(' ', soy.$$escapeHtml(cData509));
  }
  output.append(' el8MRItem" role="listitem" _mr_list="', soy.$$escapeHtml(opt_data.listName), '" _mr_index="', soy.$$escapeHtml(opt_data.index), '"></div>');
  if (!opt_sb) return output.toString();
};
